.amba-form {
  width: 100%;
  max-width: 460px;
  border-radius: 20px;
  box-shadow: 0 3px 20px 0 rgba(0, 0, 0, 0.05);
  border: 1px solid #ddd;
  text-align: center;
  background-color: #fff;
  padding: 18px 18px 12px 18px;

  .form-top-line {
    height: 10px;
    margin: -20px -18px 12px -18px;
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
    background: linear-gradient(to left, var(--secondary-color), var(--primary-color));
  }

  .required-text {
    font-size: 12px;
    color: #555;
  }

  .campaign-root {
    padding-top: 11px;
  }

  .affiliation {
    font-family: Rawline, Arial, "Helvetica Neue", Helvetica, sans-serif;
    color: #555;
  }

  .title {
    font-family: Rawline, Arial, "Helvetica Neue", Helvetica, sans-serif;
    font-weight: 600;
    font-size: 30px;
    margin-top: 5px;
    margin-bottom: 5px;
  }

  .sub-title {
    font-family: Rawline, Arial, "Helvetica Neue", Helvetica, sans-serif;
    font-size: 14px;
    color: #555;
  }

  .input-text {
    margin-bottom: 0.7em;
    background-color: white !important;
  }

  .campaign-field {
    margin-bottom: 0.7em;
  }

  @media (max-width: 768px) {

    .input-text,
    select {
      font-size: 14px !important;

      &::placeholder {
        font-size: 14px !important;
      }
    }

    .button_ambassador {
      width: 80% !important;
      height: 36px;
    }

    .btn-root {
      padding-top: 7px !important;
    }
  }

  .input-text,
  select {
    font-family: Rawline, Arial, "Helvetica Neue", Helvetica, sans-serif !important;
    border-radius: 30px !important;
    width: 100% !important;
    color: #555 !important;
    font-size: 16px !important;

    option {
      background-color: white !important;

      &:first-child {
        color: #bbb;
      }
    }

    &::placeholder {
      font-family: Rawline, Arial, "Helvetica Neue", Helvetica, sans-serif;
      color: #555;
      font-size: 16px;
    }
  }

  .button_ambassador {
    width: 58%;
    height: 44px;
    border-radius: 40px;
    color: #fff;
    border: none;
  }

  .sub-title-root {
    padding-bottom: 9px;
    padding-top: 3px;
  }

  .btn-root {
    padding-top: 7px;
  }

  select {
    padding: 9px;
    background: white url("data:image/svg+xml;utf8,<svg viewBox='0 0 140 140' width='14' height='8' xmlns='http://www.w3.org/2000/svg'><g><path d='m121.3,34.6c-1.6-1.6-4.2-1.6-5.8,0l-51,51.1-51.1-51.1c-1.6-1.6-4.2-1.6-5.8,0-1.6,1.6-1.6,4.2 0,5.8l53.9,53.9c0.8,0.8 1.8,1.2 2.9,1.2 1,0 2.1-0.4 2.9-1.2l53.9-53.9c1.7-1.6 1.7-4.2 0.1-5.8z' fill='gray'/></g></svg>") no-repeat !important;
    background-position: right 5px top 50% !important;
    appearance: none;
  }

  .btn-submit {
    background-color: var(--primary-color);
    font-weight: 600;
  }

  @media (max-width: 768px) {
    .text-danger {
      width: 61% !important;
    }
  }

  .text-danger {
    position: absolute;
    margin: -29px 114px;
    width: 50%;
  }

  .text-danger-campaign {
    margin: -17px 114px;
  }
}

@media (max-width: 768px) {
  .amba-form {

    .sub-title-root {
      padding-bottom: 9px;
      padding-top: 3px;
    }

    .title {
      font-size: 24px;
    }

    .MuiOutlinedInput-root .MuiInputBase-input {
      height: 0.8em;
    }

    .MuiInputLabel-root {
      font-size: 12px;
    }
  }
}

@media (max-width: 420px) {
  .amba-form {
    .form-top-line {
      display: none;
    }
  }
}

.p-3 {
  padding: 3%;
}

:root {
  --app-font: "Montserrat", sans-serif;
  --primary-color: #000;
  --secondary-color: #000;
}

$primaryColor: var(--primary-color);
$secondaryColor: var(--secondary-color);

.border-top-designed {
  border-radius: 20px;
  position: relative;
  margin: 1em;
}

.border-top-designed:first-child:before {
  content: "";
  position: absolute;
  width: 453.1px;
  height: 9px;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  background: linear-gradient(to left, $secondaryColor, $primaryColor);
  top: -1px;
  left: 1.5px;
}

.ambassador-dialog-content {
  text-align: center;
  margin-bottom: 36px;
  margin-top: 25px;
}

.ambassador-dialog-container {
  position: relative;
  display: inline-block;
}

.ambassador-dialog-circle {
  width: 152px;
  height: 152px;
  background-color: #f2f2f2;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.dialog-title {
  font-size: 26px;
  color: #4caf50;
  padding-top: 10px;
  font-weight: 600;
}

.dialog-description {
  padding-top: 10px;
  font-size: 14px;
}